var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmbassador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0799 9.08003V15.92C21.0799 17.04 20.4799 18.08 19.5099 18.65L13.5699 22.08C12.5999 22.64 11.3999 22.64 10.4199 22.08L4.47991 18.65C3.50991 18.09 2.90991 17.05 2.90991 15.92V9.08003C2.90991 7.96003 3.50991 6.91999 4.47991 6.34999L10.4199 2.92C11.3899 2.36 12.5899 2.36 13.5699 2.92L19.5099 6.34999C20.4799 6.91999 21.0799 7.95003 21.0799 9.08003Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 11.5001C13.2867 11.5001 14.3299 10.4569 14.3299 9.17004C14.3299 7.88322 13.2867 6.84009 11.9999 6.84009C10.7131 6.84009 9.66992 7.88322 9.66992 9.17004C9.66992 10.4569 10.7131 11.5001 11.9999 11.5001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.1601C16 15.3601 14.21 13.9001 12 13.9001C9.79 13.9001 8 15.3601 8 17.1601",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbassador);
export default __webpack_public_path__ + "static/media/ambassador.a879eb6c21a80d5a145dda69e34ee828.svg";
export { ForwardRef as ReactComponent };